
export function parsePriceMatrix (csvMatrix) {
  let matrix = csvMatrix.trim().split('\n').map(item => item.split(';'))
  const headings = matrix
    .shift()
    .slice(1)
    .map(e => e.trim())

  let parsed = {}

  matrix = matrix.map(values => {
    const length = parseFloat(values.shift()).toFixed(2)
    return {
      [length]: headings.reduce(
        (obj, key, index) => ({ ...obj, [key]: values[index] }),
        {}
      )
    }
  })
  for (const i in matrix) {
    parsed = { ...parsed, ...matrix[i] }
  }
  return parsed
}

export function getSortedLengths (parsedMatrix) {
  return Object.keys(parsedMatrix)
    .map((a) => parseFloat(a))
    .sort((a, b) => a - b)
}
